import { createRootRoute, createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import * as z from 'zod';
var Main = lazy(function () { return import(/* webpackChunkName: "Main" */ './components/Main'); });
var Login = lazy(function () { return import(/* webpackChunkName: "Login" */ './components/Login'); });
var LoginCallback = lazy(function () { return import(/* webpackChunkName: "LoginCallback" */ '@okta/okta-react').then(function (m) { return ({ default: m.LoginCallback }); }); });
var AuthRequired = lazy(function () { return import(/* webpackChunkName: "AuthRequired" */ './components/auth/SecuredRoute').then(function (m) { return ({ default: m.AuthRequired }); }); });
import { OhCrap } from './components/ohCrap'; // maybe rename this? Or not. I like 'Oh Crap'.
import RootComponent from './App';
// this should go somewhere else more convenient as itll be used in a menu in various places.
var sortysort = {
    importDate: { realName: 'Import Date', apiName: 'importDate' },
    stage: { realName: 'Stage', apiName: 'stage' },
    category: { realName: 'Category', apiName: 'category' },
    assetName: { realName: 'Asset Name', apiName: 'asset_Name' },
    fileName: { realName: 'File Name', apiName: 'fileName' },
    firstShow: { realName: 'First Show', apiName: 'first_Show' }
};
var baseSchema = z.object({
    srch: z.string().optional(),
    fltr: z.string().optional(),
    sortBy: z.enum(Object.values(sortysort).map(function (v) { return v.apiName; })).optional(),
    sortDir: z.enum(['asc', 'desc']).optional(),
    pg: z.string().regex(/^\d+$/).optional(),
    pgSz: z.string().regex(/^\d+$/).optional(),
})
    .strict();
var collectionSchema = baseSchema;
var scopeSchema = collectionSchema.extend({
    scpp: z.string().optional(),
});
var validateBaseSearch = function (search) {
    var result = baseSchema.safeParse(search);
    if (!result.success) {
        throw new Error('Invalid search parameters - ' + result.error.issues[0].message);
    }
    return result.data;
};
var validateCollectionSearch = function (search) {
    var result = collectionSchema.safeParse(search);
    if (!result.success) {
        throw new Error('Invalid search parameters - ' + result.error.issues[0].message);
    }
    return result.data;
};
var validateScopeSearch = function (search) {
    var result = scopeSchema.safeParse(search);
    if (!result.success) {
        throw new Error('Invalid search parameters - ' + result.error.issues[0].message);
    }
    return result.data;
};
var Root = createRootRoute({
    component: RootComponent,
    notFoundComponent: function () { return OhCrap({ error: 'Page not found' }); }
});
// Layout route that wraps protected routes with AuthRequired
var authLayoutRoute = createRoute({
    getParentRoute: function () { return Root; },
    id: 'auth-layout',
    component: AuthRequired
});
var indexRoute = createRoute({
    getParentRoute: function () { return authLayoutRoute; },
    path: '/',
    component: Main,
    validateSearch: validateBaseSearch,
    errorComponent: function (_a) {
        var error = _a.error;
        return OhCrap({ error: error.message });
    }
});
var staticColRoute = createRoute({
    getParentRoute: function () { return authLayoutRoute; },
    path: '/col/stat/$staticId',
    component: Main,
    validateSearch: validateCollectionSearch,
    errorComponent: function (_a) {
        var error = _a.error;
        return OhCrap({ error: error.message });
    }
});
var scopedRoute = createRoute({
    getParentRoute: function () { return authLayoutRoute; },
    path: '/scp',
    component: Main,
    validateSearch: validateScopeSearch,
    errorComponent: function (_a) {
        var error = _a.error;
        return OhCrap({ error: error.message });
    }
});
var loginRoute = createRoute({
    getParentRoute: function () { return Root; },
    path: '/login',
    component: Login
});
var oidcCallbackRoute = createRoute({
    getParentRoute: function () { return Root; },
    path: '/oidc/callback',
    component: LoginCallback
});
export var routeTree = Root.addChildren([
    authLayoutRoute.addChildren([
        indexRoute,
        staticColRoute,
        scopedRoute
    ]),
    loginRoute,
    oidcCallbackRoute
]);
